const containerStyle = {
  flex: "unset",
  width: "auto",
};

const filterGrpContainerStyle = {
  backgroundColor: "unset",
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: "24px",
};

const resetButtonStyles = {
  textDecoration: "none",
};

export { containerStyle, filterGrpContainerStyle, resetButtonStyles };
